/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.SheetForecast = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The SheetForecast model module.
   * @module model/SheetForecast
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>SheetForecast</code>.
   * @alias module:model/SheetForecast
   * @class
   */
  var exports = function() {
    var _this = this;










  };

  /**
   * Constructs a <code>SheetForecast</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/SheetForecast} obj Optional instance to populate.
   * @return {module:model/SheetForecast} The populated <code>SheetForecast</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('Name')) {
        obj['Name'] = ApiClient.convertToType(data['Name'], 'String');
      }
      if (data.hasOwnProperty('OwnerID')) {
        obj['OwnerID'] = ApiClient.convertToType(data['OwnerID'], 'Integer');
      }
      if (data.hasOwnProperty('StartDate')) {
        obj['StartDate'] = ApiClient.convertToType(data['StartDate'], 'Date');
      }
      if (data.hasOwnProperty('EndDate')) {
        obj['EndDate'] = ApiClient.convertToType(data['EndDate'], 'Date');
      }
      if (data.hasOwnProperty('RollingPeriod')) {
        obj['RollingPeriod'] = ApiClient.convertToType(data['RollingPeriod'], 'Boolean');
      }
      if (data.hasOwnProperty('RollingHistoryMonths')) {
        obj['RollingHistoryMonths'] = ApiClient.convertToType(data['RollingHistoryMonths'], 'Integer');
      }
      if (data.hasOwnProperty('IsBudget')) {
        obj['IsBudget'] = ApiClient.convertToType(data['IsBudget'], 'Boolean');
      }
      if (data.hasOwnProperty('AggregateAutomatically')) {
        obj['AggregateAutomatically'] = ApiClient.convertToType(data['AggregateAutomatically'], 'Boolean');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {String} Name
   * @default ''
   */
  exports.prototype['Name'] = '';
  /**
   * @member {Integer} OwnerID
   * @default 0
   */
  exports.prototype['OwnerID'] = 0;
  /**
   * @member {Date} StartDate
   */
  exports.prototype['StartDate'] = undefined;
  /**
   * @member {Date} EndDate
   */
  exports.prototype['EndDate'] = undefined;
  /**
   * @member {Boolean} RollingPeriod
   * @default false
   */
  exports.prototype['RollingPeriod'] = false;
  /**
   * @member {Integer} RollingHistoryMonths
   */
  exports.prototype['RollingHistoryMonths'] = undefined;
  /**
   * @member {Boolean} IsBudget
   * @default false
   */
  exports.prototype['IsBudget'] = false;
  /**
   * @member {Boolean} AggregateAutomatically
   * @default false
   */
  exports.prototype['AggregateAutomatically'] = false;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


